export default "__VITE_ASSET__CGvIjWwG__"